module.exports = __webpack_public_path__ + "static/img/5506_phase_function_Paper_PointsHejduk_Prediction.f813c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5506_phase_function_Paper_PointsHejduk_Prediction.png
// module id = u4c8
// module chunks = 0